import React from 'react';
import type { RuntimeStatus } from '../types/ui';

interface ControlsProps {
  status: RuntimeStatus;
  isLoggedIn: boolean;
  onRun: () => void;
  onSubmit: () => void;
  onResetCode: () => void;
  showSubmit?: boolean;
}

export const Controls: React.FC<ControlsProps> = ({ 
  status, 
  isLoggedIn,
  onRun, 
  onSubmit, 
  onResetCode,
  showSubmit = true
}) => {
  const isReady = status === 'ready';
  const isMac = typeof navigator !== 'undefined' && /Mac/.test(navigator.userAgent);
  const submitKey = isMac ? '⌘+Enter' : 'Ctrl+Enter';

  return (
    <div className="controls-container">
      <div className="tooltip-container">
        <button 
          onClick={onRun} 
          disabled={!isReady} 
          className="run-button"
        >
          Run
        </button>
        <div className="tooltip">Shift+Enter</div>
      </div>
      {isLoggedIn && showSubmit && (
        <div className="tooltip-container">
          <button 
            onClick={onSubmit} 
            disabled={!isReady} 
            className="submit-button"
            title="Submit code for final grading"
          >
            Submit
          </button>
          <div className="tooltip">{submitKey}</div>
        </div>
      )}
      <button onClick={onResetCode} title="Reset code to starter template">
        Reset Code
      </button>
    </div>
  );
};